
import * as React from 'react'
import { Text, View, ScrollView, TouchableOpacity, Image, ActivityIndicator, TextInput } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { Step } from '../components'
import images from '../../assets'
import axios from 'axios'
import { showMessage } from "react-native-flash-message"
import moment from 'moment'
import Collapsible from 'react-native-collapsible'
import { Modal, SlideAnimation } from 'react-native-modals'
import _ from 'lodash'
import qs from 'qs'

export default React.memo(function Points({ navigation, route }) {
    const { colors, fontFamily } = useTheme()
    const insets = useSafeAreaInsets()
    const [collapse, setCollapse] = React.useState({
        start: false,
        end: false
    })
    const [collapse_trip, setCollapseTrip] = React.useState(false)
    const [progress, setProgress] = React.useState(false)
    const { booking } = route.params
    const [modal_search, setModalSearch] = React.useState({
        visible: false,
        is_start: true,
        search: null,
    })
    const [list_search, setListSearch] = React.useState([])
    const [list_start_end, setListStartEnd] = React.useState({
        pick_up: { ...booking.pick_up, is_transit: booking.transit?.departure },
        drop_off: { ...booking.drop_off, is_transit: booking.transit?.destination },
    })

    console.log(booking)

    React.useEffect(() => {
        axios.get(`trip-detail?trip_id=${booking.trip?.id}`).then(res => {
            console.log(res)
            let journey = res.data.journey
            let list_start = journey.filter(item => item.parent_place_id === booking.departure.id)
            let list_end = journey.filter(item => item.parent_place_id === booking.destination.id)
            let start = journey.find(item => item.place_id === booking.pick_up.id)
            let end = journey.find(item => item.place_id === booking.drop_off.id)
            setListStartEnd({ ...list_start_end, list_start, list_end, start, end })
            console.log(list_start, list_end)
        })
    }, [])

    const toUpdate = () => {
        let tmp = { ...booking }
        tmp.pick_up = list_start_end.pick_up
        tmp.drop_off = list_start_end.drop_off
        navigation.navigate('UpdateTicket', { booking: tmp })
    }

    const searchPlace = React.useCallback(_.debounce((value) => {
        console.log(value)
        if (value && value.trim().length > 3) {
            axios.get(`https://apigw.haivan.com/api/maps/places?input=${value}&channel=WEBHAIVAN`)
                .then(res => {
                    console.log(res)
                    if (res.status === 200 && res.data.data)
                        setListSearch(res.data.data)
                    else setListSearch([])
                })
        } else setListSearch([])
    }, 500), [])

    const detailPlace = (id) => {
        setModalSearch({ ...modal_search, visible: false })
        setProgress(true)
        axios.get(`https://apigw.haivan.com/api/maps/places/detail?place_id=${id}&channel=WEBHAIVAN`)
            .then(res => {
                console.log(res)
                if (res.status === 200) {
                    let place_ids = modal_search.is_start ? list_start_end.list_start.map(item => {
                        return item.place_id
                    }) : list_start_end.list_end.map(item => {
                        return item.place_id
                    })
                    let location = `${res.data.location.lat},${res.data.location.lng}`
                    let type = modal_search.is_start ? 1 : 2
                    let trip_id = booking.trip.id

                    axios.get(`is_transit?${qs.stringify({
                        place_ids, location, type, trip_id
                    })}`)
                        .then(response => {
                            console.log(response)
                            if (modal_search.is_start) {
                                let pick_up = {
                                    ...list_start_end.pick_up,
                                    "address": res.data.name,
                                    "coordinates": res.data.location,
                                    "is_transit": response.data?.data?.length > 0 ? true : false
                                }
                                console.log(pick_up)
                                setListStartEnd({ ...list_start_end, pick_up })
                            }
                            else {
                                let drop_off = {
                                    ...list_start_end.drop_off,
                                    "address": res.data.name,
                                    "coordinates": res.data.location,
                                    "is_transit": response.data?.data?.length > 0 ? true : false
                                }
                                setListStartEnd({ ...list_start_end, drop_off })
                            }
                        })
                        .catch(err => console.log(err.response))
                        .finally(() => setProgress(false))
                }
            })
    }

    return (
        <View style={{ flex: 1, position: 'relative' }}>
            <View style={{ backgroundColor: colors.primary, paddingTop: insets.top ? insets.top : 0 }}>
                <View style={{
                    flexDirection: 'row', justifyContent: 'center', alignItems: 'center', height: 48,
                    position: 'relative',
                }}>
                    <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 18 }}>Chọn điểm đi - điểm đến</Text>
                    <View style={{ position: 'absolute', height: '100%', left: 0, top: 0 }}>
                        <TouchableOpacity onPress={() => navigation.pop()}
                            style={{ height: '100%', justifyContent: 'center', alignItems: 'center', paddingLeft: 16 }}>
                            <Image source={images.icons.back} style={{ width: 16, height: 16 }} />
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
            <View>
                <Step step={4} />
            </View>

            <ScrollView showsVerticalScrollIndicator={false}>
                <View style={{ backgroundColor: 'white' }}>
                    <TouchableOpacity style={{
                        flexDirection: 'row', paddingHorizontal: 16, paddingTop: 8, paddingBottom: 6,
                        justifyContent: 'center', alignItems: 'center'
                    }} onPress={() => setCollapseTrip(!collapse_trip)}>
                        <Image source={images.icons.back} style={{ width: 16, height: 16, marginRight: 8, transform: [{ rotate: collapse_trip ? '90deg' : '-90deg' }] }} />
                        <Text style={{ fontFamily: fontFamily.bold, flex: 1 }} numberOfLines={1}>{booking.trip?.node?.route?.name}</Text>
                        <Text style={{ fontFamily: fontFamily.bold, marginLeft: 8 }}>{moment(booking.trip?.date, 'DD-MM-YYYY').format('DD/MM/YYYY')}</Text>
                    </TouchableOpacity>
                    {
                        <Collapsible collapsed={!collapse_trip}>
                            <View style={{ width: '100%', height: 1, backgroundColor: 'rgba(202, 203, 208, 0.5)' }} />
                            <View style={{ flexDirection: 'column', paddingHorizontal: 16, paddingTop: 6, paddingBottom: 8 }}>
                                <View style={{ flexDirection: 'row' }}>
                                    <View style={{ flexDirection: 'column', alignItems: 'center', paddingTop: 6, paddingBottom: 4 }}>
                                        <View style={{ width: 6, height: 6, backgroundColor: '#050505', borderRadius: 3 }} />
                                        <View style={{ backgroundColor: '#050505', width: 2, height: 20, marginVertical: 4 }} />
                                        <View style={{ width: 6, height: 6, backgroundColor: '#050505' }} />
                                    </View>
                                    <View style={{ flexDirection: 'column', justifyContent: 'space-between', marginLeft: 8, marginRight: 16 }}>
                                        <Text style={{ fontSize: 16, fontFamily: fontFamily.bold, marginBottom: 8 }}>{moment(list_start_end.start?.place_time).format('HH:mm')}</Text>
                                        <Text style={{ fontSize: 16, fontFamily: fontFamily.bold }}>{moment(list_start_end.end?.place_time).format('HH:mm')}</Text>
                                    </View>
                                    <View style={{ flexDirection: 'column', justifyContent: 'space-between', flex: 1 }}>
                                        <Text style={{ fontSize: 16, fontFamily: fontFamily.bold }} numberOfLines={1}>{list_start_end.start?.place_name}</Text>
                                        <Text style={{ fontSize: 16, fontFamily: fontFamily.bold }} numberOfLines={1}>{list_start_end.end?.place_name}</Text>
                                    </View>
                                </View>
                            </View>
                            {
                                moment(booking.trip?.time, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss') !== list_start_end.start?.place_time ? <>
                                    <View style={{ width: '100%', height: 1, backgroundColor: 'rgba(202, 203, 208, 0.5)' }} />
                                    <View style={{ flexDirection: 'row', paddingHorizontal: 16, paddingVertical: 6 }}>
                                        <Text style={{ color: '#CF1820', fontFamily: fontFamily.bold }}>*Khởi hành lúc {moment(booking.trip?.time, 'DD-MM-YYYY HH:mm').format('HH:mm - DD/MM')}</Text>
                                    </View>
                                </> : null
                            }
                        </Collapsible>
                    }
                </View>

                {
                    list_start_end?.list_start || list_start_end?.list_end ? <>
                        <View style={{ marginTop: 6 }}>
                            {
                                list_start_end?.list_start?.length > 0 ? <>
                                    <TouchableOpacity style={{
                                        height: 45, backgroundColor: 'white', paddingHorizontal: 16, alignItems: 'center', flexDirection: 'row',
                                        borderBottomColor: 'rgba(202, 203, 208, 0.5)', borderBottomWidth: 1
                                    }} onPress={() => {
                                        collapse.start = !collapse.start
                                        setCollapse({ ...collapse })
                                    }}>
                                        <View style={{ width: 16, height: 16, backgroundColor: colors.primary, borderRadius: 8 }} />
                                        <Text style={{ marginLeft: 18, flex: 1, fontSize: 16, fontFamily: fontFamily.semi_bold }}>Điểm đi</Text>
                                        <Image source={images.icons.back} style={{ width: 16, height: 16, transform: [{ rotate: !collapse.start ? '-90deg' : '90deg' }] }} />
                                    </TouchableOpacity>
                                    <Collapsible collapsed={!collapse.start}>
                                        <TouchableOpacity style={{
                                            flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center',
                                            paddingHorizontal: 16, paddingVertical: 12, borderBottomColor: 'rgba(202, 203, 208, 0.5)', borderBottomWidth: 1
                                        }} onPress={() => setModalSearch({ ...modal_search, visible: true, is_start: true })}>
                                            <Image source={images.icons.search} style={{ width: 16, height: 16, tintColor: '#223DA4' }} />
                                            <Text style={{ marginLeft: 8, color: '#223DA4', fontFamily: fontFamily.bold }}>Tìm điểm chính xác</Text>
                                        </TouchableOpacity>
                                        <View>
                                            {
                                                list_start_end?.list_start?.map((item, index) => {
                                                    return <TouchableOpacity key={index} onPress={() => {
                                                        let pick_up = {
                                                            address: item.place_name,
                                                            id: item.place_id,
                                                            coordinates: null
                                                        }
                                                        setListStartEnd({ ...list_start_end, start: item, pick_up })
                                                        setCollapse({ start: false, end: true })
                                                    }}>
                                                        <View style={{
                                                            flexDirection: 'row', height: 52, alignItems: 'center', paddingHorizontal: 16,
                                                            borderBottomColor: 'rgba(202, 203, 208, 0.5)', borderBottomWidth: 1
                                                        }}>
                                                            <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                <Image source={images.icons.pin} style={{ width: 16, height: 16 }} />
                                                                <Text style={{ marginLeft: 8, fontSize: 16, fontFamily: fontFamily.semi_bold }}>{moment(item.place_time).format('HH:mm')}</Text>
                                                            </View>
                                                            <View style={{ justifyContent: 'center', paddingHorizontal: 8, flex: 1 }}>
                                                                <Text style={{ fontSize: 16, fontFamily: fontFamily.semi_bold }} numberOfLines={1}>{item.place_name}</Text>
                                                            </View>
                                                            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                <Image source={item.place_id === list_start_end.start.place_id ? images.icons.radio_on : images.icons.radio_off} style={{ width: 16, height: 16 }} />
                                                            </View>
                                                        </View>
                                                    </TouchableOpacity>
                                                })
                                            }
                                        </View>
                                    </Collapsible>
                                </> : null
                            }

                            {
                                list_start_end?.list_end?.length > 0 ? <>
                                    <TouchableOpacity style={{
                                        height: 45, backgroundColor: 'white', paddingHorizontal: 16, alignItems: 'center', flexDirection: 'row',
                                        borderBottomColor: 'rgba(202, 203, 208, 0.5)', borderBottomWidth: 1
                                    }} onPress={() => {
                                        collapse.end = !collapse.end
                                        setCollapse({ ...collapse })
                                    }}>
                                        <View style={{ width: 16, height: 16, backgroundColor: colors.primary }} />
                                        <Text style={{ marginLeft: 18, flex: 1, fontSize: 16, fontFamily: fontFamily.semi_bold }}>Điểm đến</Text>
                                        <Image source={images.icons.back} style={[{ width: 16, height: 16, transform: [{ rotate: !collapse.end ? '-90deg' : '90deg' }] }]} />
                                    </TouchableOpacity>
                                    <Collapsible collapsed={!collapse.end}>
                                        <TouchableOpacity style={{
                                            flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center',
                                            paddingHorizontal: 16, paddingVertical: 12, borderBottomColor: 'rgba(202, 203, 208, 0.5)', borderBottomWidth: 1
                                        }} onPress={() => setModalSearch({ ...modal_search, visible: true, is_start: false })}>
                                            <Image source={images.icons.search} style={{ width: 16, height: 16, tintColor: '#223DA4' }} />
                                            <Text style={{ marginLeft: 8, color: '#223DA4', fontFamily: fontFamily.bold }}>Tìm điểm chính xác</Text>
                                        </TouchableOpacity>
                                        <View>
                                            {
                                                list_start_end?.list_end?.map((item, index) => {
                                                    return <TouchableOpacity key={index} onPress={() => {
                                                        let drop_off = {
                                                            address: item.place_name,
                                                            id: item.place_id,
                                                            coordinates: null
                                                        }
                                                        setListStartEnd({ ...list_start_end, end: item, drop_off })
                                                        setCollapse({ ...collapse, end: false })
                                                    }}>
                                                        <View style={{
                                                            flexDirection: 'row', height: 52, alignItems: 'center', paddingHorizontal: 16,
                                                            borderBottomColor: 'rgba(202, 203, 208, 0.5)', borderBottomWidth: 1
                                                        }}>
                                                            <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                <Image source={images.icons.pin} style={{ width: 16, height: 16 }} />
                                                                <Text style={{ marginLeft: 8, fontSize: 16, fontFamily: fontFamily.semi_bold }}>{moment(item.place_time).format('HH:mm')}</Text>
                                                            </View>
                                                            <View style={{ justifyContent: 'center', paddingHorizontal: 8, flex: 1 }}>
                                                                <Text style={{ fontSize: 16, fontFamily: fontFamily.semi_bold }} numberOfLines={1}>{item.place_name}</Text>
                                                            </View>
                                                            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                <Image source={item.place_id === list_start_end.end.place_id ? images.icons.radio_on : images.icons.radio_off} style={{ width: 16, height: 16 }} />
                                                            </View>
                                                        </View>
                                                    </TouchableOpacity>
                                                })
                                            }
                                        </View>
                                    </Collapsible>
                                </> : null
                            }
                        </View>
                    </> : <View style={{ justifyContent: 'center', alignItems: 'center', marginTop: 16 }}>
                        <ActivityIndicator color={colors.primary} />
                    </View>
                }
            </ScrollView>

            <View style={{
                paddingHorizontal: 16, paddingTop: 12, paddingBottom: 12 + insets.bottom, backgroundColor: 'white',
                borderTopWidth: 1, borderTopColor: '#CACBD0', flexDirection: 'column'
            }}>
                {
                    Object.values(list_start_end).length > 0 && list_start_end.start && list_start_end.end &&
                        (list_start_end.start?.place_id !== booking.departure?.id || list_start_end.end?.place_id !== booking.destination?.id
                            || list_start_end.pick_up?.address !== booking.departure?.name || list_start_end.drop_off !== booking.destination?.name) ?
                        <View style={{ flexDirection: 'row', borderBottomColor: '#CACBD0', borderBottomWidth: 1, paddingBottom: 8 }}>
                            <View style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: 16, paddingTop: 1 }}>
                                {
                                    list_start_end.pick_up?.address !== list_start_end.start?.place_name ? <>
                                        <View style={{ borderColor: '#050505', width: 6, height: 6, borderRadius: 3, borderWidth: 1, marginTop: 2 }} />
                                        <View style={{ backgroundColor: '#050505', width: 2, height: 1, marginTop: 4 }} />
                                        <View style={{ backgroundColor: '#050505', width: 2, height: 2, marginVertical: 2 }} />
                                        <View style={{ backgroundColor: '#050505', width: 2, height: 1, marginBottom: 4 }} />
                                    </> : null
                                }
                                <View style={{ backgroundColor: '#050505', width: 6, height: 6, borderRadius: 3 }} />
                                <View style={{ backgroundColor: '#050505', width: 2, height: 18, marginVertical: 2 }} />
                                <View style={{ backgroundColor: '#050505', width: 6, height: 6, marginBottom: 4 }} />
                                {
                                    list_start_end.drop_off?.address !== list_start_end.end?.place_name ? <>
                                        <View style={{ backgroundColor: '#050505', width: 2, height: 1 }} />
                                        <View style={{ backgroundColor: '#050505', width: 2, height: 2, marginVertical: 2 }} />
                                        <View style={{ backgroundColor: '#050505', width: 2, height: 1, marginBottom: 4 }} />
                                        <View style={{ borderColor: '#050505', width: 6, height: 6, borderWidth: 1, marginBottom: 2 }} />
                                    </> : null
                                }
                            </View>
                            <View style={{ flex: 1, marginLeft: 6 }}>
                                {
                                    list_start_end.pick_up?.address !== list_start_end.start?.place_name ? <View style={{ flexDirection: 'row', marginBottom: 3, justifyContent: 'center', alignItems: 'center' }}>
                                        <Text style={{ fontSize: 14, fontFamily: fontFamily.bold }}>
                                            {list_start_end.pick_up?.is_transit ? 'Trung chuyển: ' : 'Tự di chuyển: '}
                                        </Text>
                                        <Text style={{ fontSize: 14, fontFamily: fontFamily.semi_regular, flex: 1 }} numberOfLines={1}>{list_start_end.pick_up?.address}</Text>
                                        <TouchableOpacity style={{ justifyContent: 'center', alignItems: 'center', paddingLeft: 4 }}
                                            onPress={() => {
                                                let pick_up = { ...pick_up, address: list_start_end.start.place_name }
                                                setListStartEnd({ ...list_start_end, pick_up })
                                            }}>
                                            <Image source={images.icons.clear} style={{ width: 14, height: 14, marginBottom: 2 }} />
                                        </TouchableOpacity>
                                    </View> : null
                                }

                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={{ fontSize: 16, fontFamily: fontFamily.bold }} numberOfLines={1}>
                                        {moment(list_start_end.start?.place_time ? list_start_end.start?.place_time : list_start_end.start?.reached_at).format('HH:mm')}
                                    </Text>
                                    <Text style={{ fontSize: 16, fontFamily: fontFamily.bold, marginLeft: 8, flex: 1 }} numberOfLines={1}>{list_start_end.start?.place_name}</Text>
                                </View>
                                <View style={{ flexDirection: 'row', marginTop: 4 }}>
                                    <Text style={{ fontSize: 16, fontFamily: fontFamily.bold }} numberOfLines={1}>
                                        {moment(list_start_end.end?.place_time ? list_start_end.end?.place_time : list_start_end.end?.reached_at).format('HH:mm')}
                                    </Text>
                                    <Text style={{ fontSize: 16, fontFamily: fontFamily.bold, marginLeft: 8, flex: 1 }} numberOfLines={1}>{list_start_end.end?.place_name}</Text>
                                </View>

                                {
                                    list_start_end.drop_off?.address !== list_start_end.end?.place_name ? <View style={{ flexDirection: 'row', marginTop: 3, justifyContent: 'center', alignItems: 'center' }}>
                                        <Text style={{ fontSize: 14, fontFamily: fontFamily.bold }}>
                                            {list_start_end.drop_off?.is_transit ? 'Trung chuyển: ' : 'Tự di chuyển: '}
                                        </Text>
                                        <Text style={{ fontSize: 14, fontFamily: fontFamily.semi_regular, flex: 1 }} numberOfLines={1}>{list_start_end.drop_off?.address}</Text>
                                        <TouchableOpacity style={{ justifyContent: 'center', alignItems: 'center', paddingLeft: 4 }}
                                            onPress={() => {
                                                let drop_off = { ...drop_off, address: list_start_end.end.place_name }
                                                setListStartEnd({ ...list_start_end, drop_off })
                                            }}>
                                            <Image source={images.icons.clear} style={{ width: 14, height: 14, marginBottom: 2 }} />
                                        </TouchableOpacity>
                                    </View> : null
                                }
                            </View>
                        </View> : null
                }

                <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
                    <Text style={{ flex: 1, fontFamily: 'Nunito_400Regular' }}>Số ghế/giường</Text>
                    <Text style={{ fontSize: 16, fontFamily: fontFamily.semi_bold }}>{booking.name}</Text>
                </View>
                <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 4 }}>
                    <Text style={{ flex: 1, fontFamily: 'Nunito_400Regular' }}>Tổng tiền</Text>
                    <Text style={{ fontSize: 16, fontFamily: fontFamily.semi_bold }}>{
                        (Intl.NumberFormat('vi-VN').format(booking.price))
                    }đ</Text>
                </View>
                <TouchableOpacity style={{
                    height: 45, backgroundColor: colors.primary, marginTop: 8,
                    justifyContent: 'center', alignItems: 'center', borderRadius: 6
                }} onPress={toUpdate}>
                    <Text style={{ fontSize: 16, fontFamily: fontFamily.semi_bold }}>Tiếp tục</Text>
                </TouchableOpacity>
            </View>

            {
                progress ? <View style={{
                    top: 0, left: 0, width: '100%', height: '100%',
                    justifyContent: "center", alignItems: "center", position: 'absolute', backgroundColor: '#FFFFFF80'
                }}>
                    <ActivityIndicator color={colors.primary} />
                </View> : null
            }

            <Modal
                visible={modal_search.visible}
                modalAnimation={new SlideAnimation({
                    slideFrom: 'bottom',
                })}
                onTouchOutside={() => setModalSearch({ ...modal_search, visible: false })}
                width={1}
                height={1}
            >
                <View style={{ flex: 1, backgroundColor: '#E5E5E5' }}>
                    <View style={{ backgroundColor: colors.primary, paddingTop: insets.top ? insets.top : 0 }}>
                        <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', height: 48, paddingHorizontal: 8 }}>
                            <TouchableOpacity style={{ padding: 8 }} onPress={() => setModalSearch({ ...modal_search, visible: false })}>
                                <Image source={images.icons.close} style={{ width: 16, height: 16 }} />
                            </TouchableOpacity>
                            <Text style={{ flex: 1, textAlign: 'center', color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>
                                {modal_search.is_start ? 'Tìm điểm đi' : 'Tìm điểm đến'}
                            </Text>
                            <TouchableOpacity style={{ padding: 8, opacity: 0 }}>
                                <Image source={images.icons.close} style={{ width: 16, height: 16 }} />
                            </TouchableOpacity>
                        </View>
                    </View>

                    <View style={{ position: 'relative', marginTop: 12, backgroundColor: 'white', marginHorizontal: 16, borderRadius: 4 }}>
                        <View style={{ height: '100%', position: 'absolute', justifyContent: 'center', alignItems: 'center' }}>
                            <Image source={images.icons.search} style={{ width: 16, height: 16, marginLeft: 12 }} />
                        </View>
                        <TextInput style={{
                            paddingRight: 12, paddingLeft: 36, fontFamily: fontFamily.semi_bold, height: 40,
                        }} placeholder='Nhập vào điểm'
                            value={modal_search.search}
                            onChangeText={search => {
                                setModalSearch({ ...modal_search, search })
                                setListSearch(null)
                                searchPlace(search)
                            }} autoFocus autoCorrect={false} />
                    </View>

                    <ScrollView showsVerticalScrollIndicator={false} keyboardShouldPersistTaps='handled'>
                        <TouchableOpacity activeOpacity={.99} style={{ paddingVertical: 8 }}>
                            {
                                list_search ? list_search?.map(item => {
                                    return <TouchableOpacity style={{
                                        paddingHorizontal: 16, paddingVertical: 8,
                                        borderBottomWidth: 1, borderBottomColor: 'rgba(202, 203, 208, 0.5)'
                                    }} key={item.id} onPress={() => detailPlace(item.id)}>
                                        <Text style={{ fontFamily: fontFamily.semi_bold }} numberOfLines={1}>{item.name}</Text>
                                        <Text style={{ fontFamily: fontFamily.regular }} numberOfLines={1}>{item.description}</Text>
                                    </TouchableOpacity>
                                }) : <View style={{
                                    justifyContent: "center", alignItems: "center", marginTop: 16
                                }}>
                                    <ActivityIndicator color={colors.primary} />
                                </View>
                            }
                        </TouchableOpacity>
                    </ScrollView>
                </View>
            </Modal>
        </View>
    )
})
